import { BaccaratValues } from './enum';
import style from './index.scss';

export const MAX_ROWS_COUNT = 6;
export const MAX_COLUMNS_COUNT = 20;
export const DEFAULT_CELL_FONT_SIZE = 5;

export const CellStyles = {
    [BaccaratValues.Player]: style.playerIcon,
    [BaccaratValues.Bank]: style.bankIcon,
    [BaccaratValues.Tie]: style.tieIcon,
    [BaccaratValues.WithTie]: style.crossedByTie
};
